import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const EmptyState = (props) => {
  const {cityName} = props;
  const findNothing = (
    <FormattedMessage id="CityPage.EmptyContent.findnothing" defaultMessage="Uh-oh, we didn’t find anything!" />
  );
  const tryDiff = (
    <FormattedMessage
      id="CityPage.EmptyContent.trydiff"
      defaultMessage="Try using different dates to find events in {cityName}."
      values={{cityName}}
    />
  );

  return (
    <div className="CityPage__EmptyContent">
      <div className="EmptyContent__img" />
      <div className="EmptyContent__findNothing">{findNothing}</div>
      <div className="EmptyContent__tryDiff">{tryDiff}</div>
    </div>
  );
};

EmptyState.propTypes = {
  cityName: PropTypes.string,
};

export default EmptyState;
